
import { useContext } from 'react'

// context
import { FilterContext } from '../../context/FilterContext'

const EmptyState = (props) => {
  const { title, description, button } = props

  const FilterContextState = useContext(FilterContext)

  const descriptionText = () => {
    return { __html: description }
  }

  return (
    <div className="EmptyState">
      <div className="EmptyState-container">
        <div className="EmptyState-inner">
          {title &&
          <div className="EmptyState-title">
            <h2>{title}</h2>
          </div>
          }
          {description &&
          <div className="EmptyState-description" dangerouslySetInnerHTML={descriptionText()}></div>
          }
          {button &&
          <div className="EmptyState-reset">
            <button className="EmptyState-button" onClick={(e) => { FilterContextState.resetFilters()}}>{ button }</button>
          </div>
          }
        </div>
      </div>
    </div>
  )
}

export default EmptyState
